import React from 'react';
import * as S from './style';

const BottomInfo = () => {
  const handleInfoClick = (e, info) => {
    let target = e.target;
    if (e.target.nodeName !== 'DIV') {
      target = e.target.parentElement;
    }
    const regex = new RegExp(info);
    if (!target.style.opacity || target.style.opacity === '1')
      target.style.opacity = 0.3;
    else target.style.opacity = 1.0;

    document.querySelectorAll('#map img').forEach(img => {
      if (regex.test(img.src)) {
        if (img.classList.contains('hide')) {
          img.classList.remove('hide');
        } else {
          img.classList.add('hide');
        }
      }
    });
  };
  const infos = ['empty', 'few', 'some', 'plenty'];
  return (
    <S.ContainerWrapper>
      <S.Container>
        <S.InfoHint>
          보여지는 정보가 너무 많다면 이 친구들을 눌러보세요!
        </S.InfoHint>
        <S.InfoContainer>
          {infos.map((info, index) => {
            return (
              <S.Info key={index} onClick={e => handleInfoClick(e, info)}>
                <S.InfoIcon src={`/img/${info}-large.png`} />
                {/* <S.InfoDescription>{info.description}</S.InfoDescription> */}
              </S.Info>
            );
          })}
        </S.InfoContainer>
      </S.Container>
    </S.ContainerWrapper>
  );
};

export default BottomInfo;
